import {Component, computed, inject, viewChild} from '@angular/core';
import {TitleCasePipe} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {GameStore} from '../../store/game.store';
import {ResourcesService} from '../../services/resources.service';
import {PanelComponent} from '../panel/panel.component';

@Component({
  selector: 'gis-share-score',
  imports: [ButtonModule, TitleCasePipe, PanelComponent],
  templateUrl: './share-score.component.html',
  styleUrl: './share-score.component.scss'
})
export class ShareScoreComponent {
  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  readonly panelComponent = viewChild(PanelComponent);

  protected hasNavigatorShare() {
    return navigator.canShare?.({title: '', text: '', url: ''}) ?? false;
  }
  protected useNavigatorShare() {
    return screen.width <= 800 && this.hasNavigatorShare();
  }

  shareApps = computed(() => {
    const texts = this.resourcesService.languageFile.value();
    const whatsAppUrl = `${this.formatScore(texts?.shareText)} ${this.store.gameUrl()}`;
    const emailBody = `${this.formatScore(texts?.shareText)} ${this.store.gameUrl()}`;
    return [
      {
        name: 'x',
        url: `https://x.com/share?url=${encodeURIComponent(this.store.gameUrl())}&text=${encodeURIComponent(this.formatScore(texts?.shareText))}`
      },
      {
        name: 'facebook',
        url: `https://www.facebook.com/sharer.php?u=${encodeURIComponent(this.store.gameUrl())}`
      },
      {
        name: 'whatsapp',
        url: `https://wa.me/send?text=${encodeURIComponent(whatsAppUrl)}`
      },
      {
        name: 'e-mail',
        url: `mailto:?body=${encodeURIComponent(emailBody)}`
      },
    ];
  });

  private hidePanelComponent() {
    const panel = this.panelComponent();
    if (panel) {
      panel.show = false;
    }
  }

  navigatorShare() {
    this.hidePanelComponent();
    const texts = this.resourcesService.languageFile.value();
    navigator.share({
      title: texts?.gameName,
      text: this.formatScore(texts?.shareText),
      url: this.store.gameUrl()
    });
  }

  copyToClipboard() {
    this.hidePanelComponent();
    const texts = this.resourcesService.languageFile.value();
    navigator.clipboard.writeText(`${this.formatScore(texts?.shareText)} ${this.store.gameUrl()}`);
  }

  closeShareButtonsPanel() {
    this.hidePanelComponent();
  }

  private formatScore(template: string | undefined): string {
    return template ? template.replace('%%', this.store.score().toString()) : '';
  }
}
